import { Injectable, Inject, Optional } from '@angular/core';
import {
  ISession,
  IUser,
  IProfile,
  SessionService as ISessionService,
  UserService as IUserService,
  ProfileService as IProfileService,
  RecoveryService as IRecoveryService,
} from '@relevance/core';

import { UserServiceConfig, USER_CONFIG } from './user.config';

/**
 * This service extends the base TypeScript session service to work with Angular DI.
 */
@Injectable()
export class SessionService<S extends ISession = ISession> extends ISessionService<S> {

  constructor(
    @Inject(USER_CONFIG) config: UserServiceConfig,
  ) {
    super(config.url, config.options);
  }

}

/**
 * This service extends the base TypeScript user service to work with Angular DI.
 */
@Injectable()
export class UserService<U extends IUser = IUser> extends IUserService<U> {

  constructor(
    @Inject(USER_CONFIG) config: UserServiceConfig,
    sessionService: SessionService,
  ) {
    super(sessionService, config.token);
  }

}

/**
 * This service extends the base TypeScript profile service to work with Angular DI.
 */
@Injectable()
export class ProfileService<P extends IProfile = IProfile> extends IProfileService<P> {

  constructor(
    @Inject(USER_CONFIG) config: UserServiceConfig,
    sessionService: SessionService,
  ) {
    super(sessionService, config.token);
  }

}

/**
 * This service extends the base TypeScript recovery service to work with Angular DI.
 */
@Injectable()
export class RecoveryService extends IRecoveryService {

  constructor(
    @Inject(USER_CONFIG) config: UserServiceConfig,
  ) {
    super(config.url);
  }

}
